
export const services = [
  {
    slug: 'gesichtsbehandlungen',
    icon: 'ri-sparkling-line',
    title: 'Gesichtsbehandlungen',
    description: 'Professionelle Gesichtsbehandlungen für jeden Hauttyp. Von der klassischen Reinigung bis zur Anti-Aging-Behandlung - wir bringen Ihre Haut zum Strahlen.',
    startingPrice: 'ab 45€'
  },
  {
    slug: 'dauerhafte-haarentfernung',
    icon: 'ri-flashlight-line',
    title: 'Dauerhafte Haarentfernung',
    description: 'Nie wieder Rasieren, Epilieren oder Waxen. Mit der geballten Kraft von drei verschiedenen Wellenlängen - für alle Hauttypen geeignet.',
    startingPrice: 'ab 1€'
  },
  {
    slug: 'waxing',
    icon: 'ri-scissors-line',
    title: 'Waxing',
    description: 'Hautschonende und effiziente Haarentfernung. Professionelles Waxing für Gesicht, Arme, Beine und Intimbereich.',
    startingPrice: 'ab 8€'
  },
  {
    slug: 'wimpern-augenbrauen',
    icon: 'ri-eye-line',
    title: 'Wimpern & Augenbrauen',
    description: 'Wimpernlifting, Browlifting, Färben und Zupfen. Betonen Sie das Schönste - Ihre Augen!',
    startingPrice: 'ab 10€'
  },
  {
    slug: 'aqua-facial',
    icon: 'ri-drop-line',
    title: 'Aqua Facial',
    description: 'Wellness für Ihre Haut! Mehrstufige Behandlung mit Reinigung, Peeling und Pflege für ein strahlendes Hautbild.',
    startingPrice: '99€'
  },
  {
    slug: 'micro-needling',
    icon: 'ri-contrast-drop-line',
    title: 'Micro-Needling (BioRePeel CL3)',
    description: 'Moderne Hautverbesserung durch Micro-Needling. Für ein ebenmäßiges, straffes und jugendliches Hautbild.',
    startingPrice: 'ab 110€'
  },
  {
    slug: 'bio-repeel',
    icon: 'ri-heart-pulse-line',
    title: 'Maniküre & Pediküre',
    description: 'Professionelle Hand- und Fußpflege für gepflegte Nägel. Von klassischer Pflege bis zu modernem Nageldesign - für Hände und Füße, die begeistern.',
    startingPrice: 'ab 10€'
  },
  {
    slug: 'microdermabrasion',
    icon: 'ri-contrast-2-line',
    title: 'Microdermabrasion',
    description: 'Sanfte mechanische Hautabtragung für ein verfeinertes Hautbild und strahlenden Teint.',
    startingPrice: 'ab 80€'
  },
  {
    slug: 'rueckenbehandlung',
    icon: 'ri-user-heart-line',
    title: 'Rückenbehandlung',
    description: 'Spezielle Behandlungen für unreine Haut am Rücken. Tiefenreinigung und Pflege für ein reines Hautbild.',
    startingPrice: 'ab 70€'
  }
];
